import { SelectFormInput } from '@/components';
import { Card, CardBody, CardHeader, Col } from 'react-bootstrap';
import RoomCard from './RoomCard';
import { useEffect, useState } from 'react';
import { accommodationsService } from '@/api/services';

const RoomOptions = ({ hotelId, hotel }) => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRooms = async () => {
      if (!hotelId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const webhotelierRooms = hotel?.webhotelier?.rooms;
        if (Array.isArray(webhotelierRooms) && webhotelierRooms.length > 0) {
          setRooms(webhotelierRooms);
        } else {
          // Fetch hotel detail which should include rooms
          const response = await accommodationsService.getById(hotelId);
          const hotelData = response.data?.data || response.data;
          
          // Get rooms from hotel data - check various possible locations
          const hotelRooms = hotelData?.rooms || 
                            hotelData?.acc_rooms || 
                            hotelData?.raw?.rooms || 
                            hotelData?.raw?.acc_rooms || 
                            [];
          
          // Filter rooms for current year if they have agreements
          const currentYear = new Date().getFullYear();
          const filteredRooms = Array.isArray(hotelRooms) 
            ? hotelRooms.filter(room => {
                // Check if room has agreements for current year
                if (room.agreements && Array.isArray(room.agreements)) {
                  return room.agreements.some(agreement => {
                    const agreementYear = agreement.year || new Date(agreement.created_at || agreement.start_date).getFullYear();
                    return agreementYear === currentYear;
                  });
                }
                // If no agreements data, include the room
                return true;
              })
            : [];
          
          setRooms(filteredRooms);
        }
      } catch (err) {
        console.error('Error fetching rooms:', err);
        setRooms([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, [hotelId, hotel?.webhotelier?.rooms]);

  if (loading) {
    return (
      <Card className="bg-transparent">
        <CardHeader className="border-bottom bg-transparent px-0 pt-0">
          <h3 className="mb-0">Room Options</h3>
        </CardHeader>
        <CardBody className="pt-4 p-0">
          <p className="text-muted">Loading rooms...</p>
        </CardBody>
      </Card>
    );
  }

  if (rooms.length === 0) {
    return (
      <Card className="bg-transparent">
        <CardHeader className="border-bottom bg-transparent px-0 pt-0">
          <h3 className="mb-0">Room Options</h3>
        </CardHeader>
        <CardBody className="pt-4 p-0">
          <p className="text-muted">No rooms available for this year.</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="bg-transparent" id="room-options">
      <CardHeader className="border-bottom bg-transparent px-0 pt-0">
        <div className="d-sm-flex justify-content-sm-between align-items-center">
          <h3 className="mb-2 mb-sm-0">Room Options</h3>
          <Col sm={4}>
            <form className="form-control-bg-light">
              <SelectFormInput className="form-select form-select-sm js-choice border-0">
                <option value={-1}>Select Option</option>
                <option>Recently search</option>
                <option>Most popular</option>
                <option>Top rated</option>
              </SelectFormInput>
            </form>
          </Col>
        </div>
      </CardHeader>
      <CardBody className="pt-4 p-0">
        <div className="vstack gap-4">
          {rooms.map((room, idx) => (
            <RoomCard key={room.id || idx} room={room} />
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default RoomOptions;

